import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-124" data-mp="1223in9l0x41b">
      <div className="mx-auto max-w-3xl" data-id="element-125" data-mp="124pp15w6hdhy">
        <h2 className="text-center font-serif text-[2rem] font-extrabold leading-tight text-navy sm:text-5xl" data-id="element-126" data-mp="1pro4q1ch4het">
          Frequently asked <span className="italic text-teal" data-id="element-127" data-mp="1upzekc2rqrx1">questions</span>
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-128" data-mp="1g367fu3eksfx">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white" data-id="element-129" data-mp="1kzo8aivm46mz" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-[17px] font-bold text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-teal" data-id="element-130" data-mp="28qa3h9kipwfk">
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-teal transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-131" data-mp="2yhcymylx4pux" />
                </button>
                <AnimatePresence initial={false} data-id="element-132" data-mp="32i59txecp4tu">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-133" data-mp="3hewd4hr5b0oq">
                      <p className="px-5 pb-5 text-base leading-relaxed text-ink-muted" data-id="element-134" data-mp="1i2bplopmansl">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <CtaButton label="I want the Rhinoplasty Master Planner™" className="mt-10" data-id="element-135" data-mp="2bsau3x8l9jqp" />
      </div>
    </section>;
}